
import { Page } from "app/multi_device"
import {
  AreaSizeDropdown,
  InputSelector as BaseInputSelector,
} from "components/dropdown_menu/desktop/area_size_dropdown"

export type InputSelector = BaseInputSelector & {
  scope?: JQuery | string
  main?: JQuery | string
  min_select?: JQuery | string
  max_select?: JQuery | string
  toggle?: JQuery | string
  dropdown?: JQuery | string
  min_wrapper?: JQuery | string
  max_wrapper?: JQuery | string
}
const DEFAULT_SELECTOR = {
  scope:        ".new_serviced_apartment_listing_search_criteria_set",
  main:         ".cell--serviced-apartments--searches--filter-bar__area-size-dropdown-container",
  min_select:   ".filter-option-min",
  max_select:   ".filter-option-max",
  toggle:       ".dropdown-with-input-toggle",
  dropdown:     ".dropdown-menu-with-input",
  max_wrapper:  ".filter-option--gross-max",
  min_wrapper:  ".filter-option--gross-min",
  angle:        ".btn i",
}


export class BuyRentDesktopAreaSizeDropdown extends AreaSizeDropdown {
  protected name: string

  constructor(selector?: InputSelector){
    const merged_selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    super(merged_selector)

    this.name = "SA_page_area_size_dropdown_blueprint"
  }
}

const Factory = {
  create(selector?: InputSelector){
    if (! Page.isForDesktop() && ! Page.isForTablet()){
      throw new Error("Desktop.SA_area_size_dropdown.AreaSizeDropDown called for incorrect page version")
    }
    return new BuyRentDesktopAreaSizeDropdown(selector)
  },
}

export {
  Factory,
  Factory as default,
}
